import { createEntityAdapter } from '@reduxjs/toolkit';
import { AdTypeExtraFeeParams } from './adTypeExtraFees.types';

const adapter = createEntityAdapter<AdTypeExtraFeeParams>();

export default adapter;
